import { gql, useMutation } from '@apollo/client';
import { DomainsInput } from 'types/graphql-types';
import { useLoginInput } from './use-login-input';

const SAVE_DOMAINS = gql`
  mutation SaveDomains($domains: DomainsInput!) {
    saveDomains(domains: $domains) {
      login
    }
  }
`;

export const useSaveDomains = (): ((
  specialization: Omit<DomainsInput, 'login'>,
) => Promise<void>) => {
  const loginInput = useLoginInput();
  const [saveSpecialization] = useMutation(SAVE_DOMAINS, {
    refetchQueries: ['GetEmployee'],
  });

  return async (domains) => {
    const opt = {
      variables: { domains: { ...loginInput, ...domains } },
    };

    await saveSpecialization(opt);
  };
};
